<template>
    <modal name="declaration-status-modal" class="declaration-status-modal"
           :width="600"
           :height="'auto'"
           @before-open="handlerBeforeOpen"
           @before-close="handlerBeforeClose"
    >
        <div class="modal_title">신고 내용</div>
        <div class="pl30 pr30 pb30 text-center">
            <el-select
                    v-model="status"
                    placeholder="처리대기"
                    class="table_s_select"
            >
                <el-option
                        :label="'처리대기'"
                        :value="1"
                ></el-option>
                <el-option
                        :label="'처리완료'"
                        :value="3"
                ></el-option>
            </el-select>
            <div class="btn_box text-center mt20">
                <el-button class="reg_btn_out" @click="closeModal()">학인</el-button>
                <el-button class="com_btn" @click="closeModal()">취소</el-button>
            </div>
        </div>
    </modal>
</template>

<script>
import EventBus from "@/utils/event-bus";

export default {
    name: "DeclarationStatusModal",
    mixins: [],
    components: {},
    inject: {},
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            declarationData: {},
            status:'',
        }
    },
    created() {
    },
    mounted() {


    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {

        handlerBeforeOpen(event) {
            this.declarationData = event.params.declarationData;
            this.status = this.declarationData.bb_status;
        },
        handlerBeforeClose() {
            this.$router.replace(this.$route.path);
        },
        closeModal() {
            this.$modal.hide('declaration-status-modal')
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
